class CartCoupon {
  constructor() {
    this.form = document.getElementById('cart-coupon-form');
    if (!this.form) return;

    this.inputGroup = document.getElementById('cart-coupon-input-group');
    this.input = document.getElementById('cart-coupon-code');
    this.button = document.getElementById('cart-coupon-apply');
    this.messageEl = document.getElementById('cart-coupon-message');
    this.appliedWrapper = document.getElementById('cart-coupon-applied');
    this.appliedText = document.getElementById('cart-coupon-applied-text');
    this.removeBtn = document.getElementById('cart-coupon-remove');

    this.form.addEventListener('submit', this.applyCoupon.bind(this));
    this.removeBtn.addEventListener('click', this.removeCoupon.bind(this));

    this.init();
  }

  // On page load, check current cart state directly from Shopify
  init() {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((res) => res.json())
      .then((cart) => this.renderState(cart))
      .catch(() => {});
  }

  applyCoupon(event) {
    event.preventDefault();
    const code = this.input.value.trim();

    if (!code) {
      this.showMessage('Please enter a coupon code.', 'error');
      return;
    }

    this.setLoading(true, this.button, 'Applying...');
    this.updateCartDiscount(code);
  }

  removeCoupon(event) {
    event.preventDefault();
    this.setLoading(true, this.removeBtn, 'Removing...');
    this.updateCartDiscount(''); // empty string clears the discount
  }

  // Uses the Ajax Cart API to set/clear the discount directly on the
  // cart object — no redirect, no cookie race condition.
  updateCartDiscount(discountCode) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: discountCode }),
    })
      .then((res) => res.json())
      .then((cart) => {
        this.renderState(cart);
        this.refreshCartFooterSection(); // update subtotal/discount line display
      })
      .catch(() => {
        this.showMessage('Something went wrong. Please try again.', 'error');
      })
      .finally(() => {
        this.setLoading(false, this.button, 'Apply');
        this.setLoading(false, this.removeBtn, 'Remove');
      });
  }

  // cart.discount_codes tells us exactly what's active and whether
  // it's valid — no guessing needed
  renderState(cart) {
    const codes = cart.discount_codes || [];
    const applied = codes.find((d) => d.applicable);
    const invalid = codes.find((d) => !d.applicable);

    if (applied) {
      this.showAppliedState(applied.code);
    } else if (invalid) {
      this.showInputState();
      this.input.value = invalid.code;
      this.showMessage(`"${invalid.code}" is invalid or expired.`, 'error');
    } else {
      this.showInputState();
      this.input.value = '';
      this.showMessage('', '');
    }
  }

  // Re-fetch just the cart footer section (from the CURRENT page URL,
  // i.e. /cart) so subtotal/discount line reflects the new state
  // without a full page reload.
  refreshCartFooterSection() {
    fetch(`${window.location.pathname}?section_id=main-cart-footer`)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newFooter = doc.querySelector('#main-cart-footer');
        const currentFooter = document.querySelector('#main-cart-footer');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
          new CartCoupon(); // re-bind since we just replaced the DOM
        }
      })
      .catch(() => {});
  }

  setLoading(isLoading, btn, loadingText) {
    if (!btn) return;
    btn.disabled = isLoading;
    btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
    btn.textContent = isLoading ? loadingText : btn.dataset.originalText;
  }

  showMessage(text, type) {
    if (!this.messageEl) return;
    this.messageEl.textContent = text;
    this.messageEl.className = text ? `cart-coupon-message ${type}` : 'cart-coupon-message';
  }

  showAppliedState(code) {
    this.inputGroup.hidden = true;
    this.appliedWrapper.hidden = false;
    this.appliedText.textContent = `Discount applied: ${code}`;
    this.showMessage('', '');
  }

  showInputState() {
    this.inputGroup.hidden = false;
    this.appliedWrapper.hidden = true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartCoupon();
});